/**
 * add-reminder-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AddReminderRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_ADD_REMINDER;
	public static tag : MessageTag = MessageTag.REQ_ADD_REMINDER;

  constructor (
    public objectId : number,
    public summary : string,
    public triggerTime : number,
    public linkedRecordId? : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/reminders/add-reminder-request.ts